import React from 'react'
import { StyledCancelButton } from './style'
import classnames from 'classnames'

const CancelButton = ({ children, className, ...rest }) => {
  return (
    <StyledCancelButton
      type="button"
      variant="link"
      className={classnames(className, 'clickable')}
      {...rest}
    >
      {children || 'Cancel'}
    </StyledCancelButton>
  )
}

export default CancelButton
